// FETCH PARTIES
export const FETCH_PARTIES_REQUEST = 'FETCH_PARTIES_REQUEST';
export const FETCH_PARTIES_SUCCESS = 'FETCH_PARTIES_SUCCESS';
export const FETCH_PARTIES_FAIL = 'FETCH_PARTIES_FAIL';
// FETCH PARTY
export const FETCH_PARTY_REQUEST = 'FETCH_PARTY_REQUEST';
export const FETCH_PARTY_SUCCESS = 'FETCH_PARTY_SUCCESS';
export const FETCH_PARTY_FAIL = 'FETCH_PARTY_FAIL';
// FETCH PARTY RELATIONS
export const FETCH_PARTY_RELATIONS_REQUEST = 'FETCH_PARTY_RELATIONS_REQUEST';
export const FETCH_PARTY_RELATIONS_SUCCESS = 'FETCH_PARTY_RELATIONS_SUCCESS';
export const FETCH_PARTY_RELATIONS_FAIL = 'FETCH_PARTY_RELATIONS_FAIL';
// FETCH PARTY ADDRESSES
export const FETCH_PARTY_ADDRESSES_REQUEST = 'FETCH_PARTY_ADDRESSES_REQUEST';
export const FETCH_PARTY_ADDRESSES_SUCCESS = 'FETCH_PARTY_ADDRESSES_SUCCESS';
export const FETCH_PARTY_ADDRESSES_FAIL = 'FETCH_PARTY_ADDRESSES_FAIL';
// FETCH PARTY MECHANISMS CONTACT
export const FETCH_PARTY_CONTACT_MECHANISMS_REQUEST = 'FETCH_PARTY_CONTACT_MECHANISMS_REQUEST';
export const FETCH_PARTY_CONTACT_MECHANISMS_SUCCESS =
  'FETCH_PARTY_CONTACT_MECHANISMS_CONTACT_SUCCESS';
export const FETCH_PARTY_CONTACT_MECHANISMS_FAIL = 'FETCH_PARTY_CONTACT_MECHANISMS_CONTACT_FAIL';
// FETCH PARTY BANK ACCOUNTS
export const FETCH_PARTY_BANK_ACCOUNTS_REQUEST = 'FETCH_PARTY_BANK_ACCOUNTS_REQUEST';
export const FETCH_PARTY_BANK_ACCOUNTS_SUCCESS = 'FETCH_PARTY_BANK_ACCOUNTS_SUCCESS';
export const FETCH_PARTY_BANK_ACCOUNTS_FAIL = 'FETCH_PARTY_BANK_ACCOUNTS_FAIL';
// FETCH PARTY DUE INVOICES
export const FETCH_PARTY_DUE_INVOICES_REQUEST = 'FETCH_PARTY_DUE_INVOICES_REQUEST';
export const FETCH_PARTY_DUE_INVOICES_SUCCESS = 'FETCH_PARTY_DUE_INVOICES_SUCCESS';
export const FETCH_PARTY_DUE_INVOICES_FAIL = 'FETCH_PARTY_DUE_INVOICES_FAIL';
// FETCH PARTY REJECTED PAYMENTS
export const FETCH_PARTY_REJECTED_PAYMENTS_REQUEST = 'FETCH_PARTY_REJECTED_PAYMENTS_REQUEST';
export const FETCH_PARTY_REJECTED_PAYMENTS_SUCCESS = 'FETCH_PARTY_REJECTED_PAYMENTS_SUCCESS';
export const FETCH_PARTY_REJECTED_PAYMENTS_FAIL = 'FETCH_PARTY_REJECTED_PAYMENTS_FAIL';
// FETCH PARTY EVENTS
export const FETCH_PARTY_EVENTS_REQUEST = 'FETCH_PARTY_EVENTS_REQUEST';
export const FETCH_PARTY_EVENTS_SUCCESS = 'FETCH_PARTY_EVENTS_SUCCESS';
export const FETCH_PARTY_EVENTS_FAIL = 'FETCH_PARTY_EVENTS_FAIL';
// FETCH PARTY CONTRACTS
export const FETCH_PARTY_CONTRACTS_REQUEST = 'FETCH_PARTY_CONTRACTS_REQUEST';
export const FETCH_PARTY_CONTRACTS_SUCCESS = 'FETCH_PARTY_CONTRACTS_SUCCESS';
export const FETCH_PARTY_CONTRACTS_FAIL = 'FETCH_PARTY_CONTRACTS_FAIL';
// FETCH GENDERS
export const FETCH_GENDERS_REQUEST = 'FETCH_GENDERS_REQUEST';
export const FETCH_GENDERS_SUCCESS = 'FETCH_GENDERS_SUCCESS';
export const FETCH_GENDERS_FAIL = 'FETCH_GENDERS_FAIL';

// PUT PARTY_PERSON
export const UPDATE_PARTY_PERSON_REQUEST = 'UPDATE_PARTY_PERSON_REQUEST';
export const UPDATE_PARTY_PERSON_SUCCESS = 'UPDATE_PARTY_PERSON_SUCCESS';
export const UPDATE_PARTY_PERSON_FAIL = 'UPDATE_PARTY_PERSON_FAIL';
// PUT PARTY_COMPANY
export const UPDATE_PARTY_COMPANY_REQUEST = 'UPDATE_PARTY_COMPANY_REQUEST';
export const UPDATE_PARTY_COMPANY_SUCCESS = 'UPDATE_PARTY_COMPANY_SUCCESS';
export const UPDATE_PARTY_COMPANY_FAIL = 'UPDATE_PARTY_COMPANY_FAIL';
// PUT PARTY_ADDRESSES
export const UPDATE_PARTY_ADDRESSES_REQUEST = 'UPDATE_PARTY_ADDRESSES_REQUEST';
export const UPDATE_PARTY_ADDRESSES_SUCCESS = 'UPDATE_PARTY_ADDRESSES_SUCCESS';
export const UPDATE_PARTY_ADDRESSES_FAIL = 'UPDATE_PARTY_ADDRESSES_FAIL';
// PUT PARTY_CONTACTS
export const UPDATE_PARTY_CONTACTS_REQUEST = 'UPDATE_PARTY_CONTACTS_REQUEST';
export const UPDATE_PARTY_CONTACTS_SUCCESS = 'UPDATE_PARTY_CONTACTS_SUCCESS';
export const UPDATE_PARTY_CONTACTS_FAIL = 'UPDATE_PARTY_CONTACTS_FAIL';
// UPDATE_PARTY_BANK_ACCOUNTS_REQUEST
export const UPDATE_PARTY_BANK_ACCOUNTS_REQUEST = 'UPDATE_PARTY_BANK_ACCOUNTS_REQUEST';
export const UPDATE_PARTY_BANK_ACCOUNTS_SUCCESS = 'UPDATE_PARTY_BANK_ACCOUNTS_SUCCESS';
export const UPDATE_PARTY_BANK_ACCOUNTS_FAIL = 'UPDATE_PARTY_BANK_ACCOUNTS_FAIL';
// UPDATE_PARTY_RELATIONS_REQUEST
export const UPDATE_PARTY_RELATIONS_REQUEST = 'UPDATE_PARTY_RELATIONS_REQUEST';
export const UPDATE_PARTY_RELATIONS_SUCCESS = 'UPDATE_PARTY_RELATIONS_SUCCESS';
export const UPDATE_PARTY_RELATIONS_FAIL = 'UPDATE_PARTY_RELATIONS_FAIL';
// CHANGE_PAYMENT_CARD
export const CHANGE_PAYMENT_CARD_REQUEST = 'CHANGE_PAYMENT_CARD_REQUEST';
export const CHANGE_PAYMENT_CARD_SUCCESS = 'CHANGE_PAYMENT_CARD_SUCCESS';
export const CHANGE_PAYMENT_CARD_FAIL = 'CHANGE_PAYMENT_CARD_FAIL';
// LOAD MORE PARTIES
export const LOAD_MORE_PARTIES_REQUEST = 'LOAD_MORE_PARTIES_REQUEST';
export const LOAD_MORE_PARTIES_SUCCESS = 'LOAD_MORE_PARTIES_SUCCESS';
export const LOAD_MORE_PARTIES_FAIL = 'LOAD_MORE_PARTIES_FAIL';

// REDIRECT
export const SET_REDIRECT = 'SET_REDIRECT';
